import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { SuccessToaster } from "../components/toaster/Toaster";
import InvoiceServices from "../../services/Invoice";
import { Form } from "./components/form";

const CreateInvoice = () => {

  const routes = all_routes;
  const navigate = useNavigate();

  // *For Loading
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  // *For Submit Form
  const createInvoice = async (payload) => {
    setLoading(true)
    try {
      const { message } = await InvoiceServices.createInvoice(payload)
      SuccessToaster(message)
      navigate(-1)
    } catch (error) {
      setError(error)
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-wrapper">
      <div className="content p-2">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New Invoice</h4>
              <h6>Create new invoice</h6>
            </div>
          </div>
        </div>
        <Form onSubmit={createInvoice} loading={loading} error={error} />
      </div>
    </div>
  );
};

export default CreateInvoice;
